import { MprcConfirmDialog, MprcIconButtonMoreOptionsDropdown, MprcRequestErrorDialog, MprcRequestIndicator, MprcText } from "components";
import { MprcFeedTypography } from "components/MprcFeedTypography";
import { MprcDropdownItems } from "components/MprcIconButtonDropdown";
import { useSnackbar } from "notistack";
import { useCoreApi } from "providers/CoreApiProvider";
import React, { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useCardContext } from "views/knowledge/components/card/CardBuilder";
import { publish } from "views/knowledge/feed/FeedEvents";

///
export const TrashedOutOptions: React.FC = () => {

    const { t } = useTranslation("knowledge");
    const api = useCoreApi();
    const { enqueueSnackbar } = useSnackbar();

    const [dialog, setDialog] = useState<any>(null);
    const [posting, setPosting] = useState<boolean>(false);
    const [viewError, setViewError] = useState<any>(null);

    const { pub: { publicationId, channel } } = useCardContext();

    type MenuOptions =
        | "restore"
        | "removePermanently";

    type MenuItem = { key: MenuOptions, label: string; checked?: boolean; };

    const groupOptions: Array<Array<MenuItem>> = [];
    const groupItems1: MenuItem[] = [];
    if (groupItems1.length > 0) groupOptions.push(groupItems1);

    // Opções do menu
    const menuItems = useMemo((): MprcDropdownItems<MenuOptions> => {
        const items: MprcDropdownItems<MenuOptions> = [];

        items.push({ text: t("Feed.Card.Options.RestoreAction"), value: "restore" });
        items.push({ text: <MprcText color="error">{t("Feed.Card.Options.RemovePermanentlyAction")}</MprcText>, value: "removePermanently" });

        return items;
    }, []);

    ///
    const doRestore = async (publicationId: string) => {
        setPosting(true);
        try {
            var result = await api.v1.knowledgePublication.restorePublication({ publicationId });
            if (result.data) {
                publish("PublicationRestored", publicationId);
                enqueueSnackbar(t("Feed.Card.Common.PublicationRestoredSuccessMessage"), { variant: "success" });
            }
            else enqueueSnackbar(t("Feed.Card.Common.PublicationRestoredErrorMessage"), { variant: "error" });
        }
        catch (e: any) {
            setViewError(e);
        }
        finally {
            setPosting(false);
        }
    };

    ///
    const doDelete = async (publicationId: string) => {
        setPosting(true);
        try {
            var result = await api.v1.knowledgePublication.deletePublication({ publicationId, permanently: true });
            if (result.data) {
                publish("PublicationPermanentlyDeleted", publicationId);
                enqueueSnackbar(t("Feed.Card.Common.PublicationPermanentlyDeletedSuccessMessage"), { variant: "success" });
            }
            else enqueueSnackbar(t("Feed.Card.Common.PublicationPermanentlyDeletedErrorMessage"), { variant: "error" });
        }
        catch (e: any) {
            setViewError(e);
        }
        finally {
            setPosting(false);
        }
    };

    ///
    const handleChooseMenuItem = (option: MenuOptions) => {
        switch (option) {
            case "removePermanently":
                doDelete(publicationId);
                break;
            case "restore":
                if (channel?.isActive == false) {
                    setDialog(
                        <MprcConfirmDialog
                            open
                            severity="question"
                            message={t("Feed.Card.Common.RestorePubChannelMessage")}
                            onClose={yes => {
                                if (yes) doRestore(publicationId);
                                setDialog(null);
                            }}
                        />
                    );
                } else {
                    doRestore(publicationId);
                }
                break;
        }
    };

    return (
        <>
            {dialog}
            <MprcRequestIndicator type="post" visible={posting} />
            <MprcRequestErrorDialog error={viewError} onClose={() => setViewError(null)} />
            <MprcFeedTypography variant="action">
                <MprcIconButtonMoreOptionsDropdown
                    items={menuItems}
                    onChange={handleChooseMenuItem}
                />
            </MprcFeedTypography>
        </>
    );
};
